module.exports = __webpack_public_path__ + "static/politica-de-privacidad-y-proteccion-datos-almesa-rev-legal-d7b5f5f4153503aa65276e6c14858ce1.pdf";